import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { URLSearchParams } from '@angular/http';
import {MatSnackBar} from '@angular/material';

import { oAuth } from '../providers/oAuth';
import { Pharmacies } from '../dataObjects/Pharmacies';
import { RxqOneARSetBatches } from '../dataObjects/RxqOneARSetBatches';
import { RxqOneARTrialBalance } from '../dataObjects/RxqOneARTrialBalance';
import { RxqOneARPrintStatements } from '../dataObjects/RxqOneARPrintStatements';
import { PrintCodes } from '../dataObjects/PrintCodes';
import { ARHistoryFile } from '../dataObjects/ARHistoryFile';
import { PharmaciesIDRequest } from '../dataObjects/PharmaciesIDRequest';
import { Customer } from '../dataObjects/Customer';
import { CustomerSearchRequest } from '../dataObjects/CustomerSearchRequest';
import { RxqOneARAgeAccounts } from '../dataObjects/RxqOneARAgeAccounts';
import {customerSearch} from '../common/customerSearch.component'
import {TemplateUploader} from '../common/TemplateUploader.component'
import {ArAge} from './arAge.component'

import { GlobalVariable } from '../common/global';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource} from '@angular/material';

import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-ar',
    templateUrl: './ar.component.html',
    styleUrls: ['./ar.component.css']
})

export class ArComponent implements OnInit {

    loading: boolean
    panelOpenState: boolean

    pharms: [Pharmacies]
    RadioSelectedValue: number
    PharmaciesSelectedValue: string
    Partition: string
    Batch: string
    FromDate: Date
    ToDate: Date

    TrialBalanceCustomerSearch: string
    TrialBalanceCustomer: Customer
    TrialBalanceRadioSelectedValue: number
    TrialBalanceTransDetailcb: boolean
    TrialBalanceTransCommentcb: boolean
    TrialBalanceAddresscb: boolean
    TrialBalanceOverduecb: boolean
    TrialBalanceFinancecb: boolean
    TrialBalanceServicecb: boolean
    TrialBalancePCcb: boolean
    TrialBalanceFinanceChargesDD = [
        { value: '<30', viewValue: 'Under 30' },
        { value: '>30', viewValue: 'Over 30' },
        { value: '>60', viewValue: 'Over 60' },
        { value: '>90', viewValue: 'Over 90' },
        { value: '>120', viewValue: 'Over 120' }
    ];
    TrialBalanceServiceChargesDD = [
        { value: 'Any', viewValue: 'With any activity or balance' },
        { value: 'Bal', viewValue: 'With a balance' },
        { value: '<30', viewValue: 'Under 30' },
        { value: '>30', viewValue: 'Over 30' },
        { value: '>60', viewValue: 'Over 60' },
        { value: '>90', viewValue: 'Over 90' },
        { value: '>120', viewValue: 'Over 120' }
    ];
    TrialBalanceReportOptionDD = [
        { value: '1', viewValue: 'PDF' },
        { value: '2', viewValue: 'JPEG' },
        { value: '3', viewValue: 'CSV' }
    ];

    TrialBalanceFinanceChargesValue: string
    TrialBalanceServiceChargesValue: string
    TrialBalanceReportOptionValue: number

    TrialBalanceReportTemplateDD = ['Manage Templates','Default']
    TrialBalanceReportTemplateValue: string

    RxqOneARSetBatchesRequest: RxqOneARSetBatches
    PrintCodesRequest: PrintCodes
    PharmaciesIDRequest: PharmaciesIDRequest

    PCdisplayedColumns = ['colPC'];

    RxqOneARPrintStatements: RxqOneARPrintStatements;

    PrintStatementsStatementDate: Date;
    PrintStatementsRadioSelectedValue: number
    PrintStatementsCustomerSearch: string
    PrintStatementsCustomer: Customer
    PrintStatementsLastNameRangecb: boolean
    PrintStatementsLastNameBeginning: string
    PrintStatementsLastNameEnding: string
    PrintStatementsPrintCodescb: boolean
    PrintStatementsPrintCodesRequest: PrintCodes
    PrintStatementsDaysRangeValue: string
    PrintStatementsDaysRangeDD = [
        { value: 'All', viewValue: 'Include All' },
        { value: '>30', viewValue: 'Over 30' },
        { value: '>60', viewValue: 'Over 60' },
        { value: '>90', viewValue: 'Over 90' },
        { value: '>120', viewValue: 'Over 120' }
    ];
    PrintStatementsPartitionBatchRadio: number;
    PrintStatementsSpecificPartition: string;
    PrintStatementsSpecificBatch: string;
    PrintStatementsOptionsDateRadioBox: number
    PrintStatementsOptionsStartDate: Date;
    PrintStatementsOptionsEndDate: Date;
    PrintStatementsShowPostingDetailscb: boolean;
    PrintStatementsShowCommentcb: boolean;
    PrintStatementsShowAddresscb: boolean;
    PrintStatementsNoCurrentPostingcb: boolean;
    PrintStatementsZeroAmountDuecb: boolean;
    PrintStatementsSortingRadioBox: number;
    PrintStatementsArRecordsRadioBox: number;
    PrintStatementsARHistoryFile: ARHistoryFile[];
    PrintStatementsArRecordsAgeRadioBox: ARHistoryFile;

    PrintStatementsReportOptionDD = [
        { value: '1', viewValue: 'PDF' },
        { value: '2', viewValue: 'JPEG' },
        { value: '3', viewValue: 'CSV' }
    ];
    PrintStatementsReportOptionValue: number;
    PrintStatementsReportTemplateDD = ['Manage Templates', 'Default']
    PrintStatementsReportTemplateValue: string

    PrintStatementsARHistoryFileDS = new MatTableDataSource<ARHistoryFile>(this.PrintStatementsARHistoryFile);

    PSARdisplayedColumns = ['colPharmId','colARAge'];

    ArAgeRadioSelectedValue: number;
    ArAgePrintCodesRequest: PrintCodes
    RxqOneARAgeAccounts: RxqOneARAgeAccounts;

    returnimage: string;
    PrintStatementsreturnimage: string;

    constructor(private http: HttpClient, public snackBar: MatSnackBar, public dialog: MatDialog, public Sanitizer: DomSanitizer) { }

    @ViewChild(MatPaginator) paginator: MatPaginator;

    ngOnInit() {
        this.loading = false;
        this.panelOpenState = true;
        this.RadioSelectedValue = 1;

        this.TrialBalanceRadioSelectedValue = 2;
        this.TrialBalanceReportTemplateValue = "Default";
        this.TrialBalanceFinanceChargesValue = "<30";
        this.TrialBalanceServiceChargesValue = "Bal";

        this.PrintStatementsStatementDate = new Date;
        this.PrintStatementsRadioSelectedValue = 2;
        this.PrintStatementsDaysRangeValue = "All";
        this.PrintStatementsPartitionBatchRadio = 1;
        this.PrintStatementsSortingRadioBox = 1;
        this.PrintStatementsArRecordsRadioBox = 1;
        this.PrintStatementsOptionsDateRadioBox = 1;
        this.PrintStatementsReportTemplateValue = "Default";
        this.PrintStatementsShowAddresscb = true;
        this.PrintStatementsNoCurrentPostingcb = true;

        this.ArAgeRadioSelectedValue = 1;

        this.PharmaciesSelectedValue = 'nothing';
        this.returnimage = '';
        this.PrintStatementsreturnimage = '';
        this.TrialBalancePCcb = false
        this.PopPharmList();
        this.loadTrialBalanceReportTemplates();
        this.loadPrintStatementsReportTemplates();
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 40000,
        });
    }

    ngAfterViewInit() {
        this.PrintStatementsARHistoryFileDS.paginator = this.paginator;
    }

    PopPharmList(): void {

        const token = JSON.parse(sessionStorage.getItem('data'));
        const tokenPayload = <oAuth>(token);

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
        };

        this.http.get(GlobalVariable.BASE_API_URL + "/api/RxqOnePharmacies", options)
            .subscribe(
            (response) => {
                const resp = <[Pharmacies]>response
                this.pharms = resp;
            },
            (err) => {
                /* this function is executed when there's an ERROR */
                console.log("ERROR: " + err);
            },
            () => {
                /* this function is executed when the observable ends (completes) its stream */
                //console.log("COMPLETED");
            }
            );
    }

    openCustomerSearchDialog(): void {
        let dialogRef = this.dialog.open(customerSearch, {
            width: '750px',
            height: '550px',
            data: { TrialBalanceCustomer: this.TrialBalanceCustomer, PharmaciesSelectedValue: this.PharmaciesSelectedValue }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.TrialBalanceCustomer = <Customer>result;
        });
    }

    openCustomerPSSearchDialog(): void {
        let dialogRef = this.dialog.open(customerSearch, {
            width: '750px',
            height: '550px',
            data: { PrintStatementsCustomer: this.PrintStatementsCustomer, PharmaciesSelectedValue: this.PharmaciesSelectedValue }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.PrintStatementsCustomer = <Customer>result;
        });
    }

    openTemplateUploaderDialog(): void {
        let dialogRef = this.dialog.open(TemplateUploader, {
            width: '750px',
            height: '550px',
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            this.loadTrialBalanceReportTemplates();
            this.TrialBalanceReportTemplateValue = '';

            this.loadPrintStatementsReportTemplates();
            this.PrintStatementsReportTemplateValue = '';
        });
    }

    openArAgeDialog(): void {
        let dialogRef = this.dialog.open(ArAge, {
            width: '350px',
            height: '250px',
            data: {PharmaciesSelectedValue: this.PharmaciesSelectedValue }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (<boolean>result == true){
                this.SubmitAgeAccountsConfirm();
            }
        });
    }

    loadTrialBalanceReportTemplates() {
        this.TrialBalanceReportTemplateDD = ['Manage Templates', 'Default']
        for (var i = 0; i < localStorage.length; i++) {

            if (localStorage.key(i).includes(".repx")) {
                this.TrialBalanceReportTemplateDD.push(localStorage.key(i).toString());
            }
        }
    }

    loadPrintStatementsReportTemplates() {
        this.PrintStatementsReportTemplateDD = ['Manage Templates', 'Default']
        for (var i = 0; i < localStorage.length; i++) {

            if (localStorage.key(i).includes(".repx")) {
                this.PrintStatementsReportTemplateDD.push(localStorage.key(i).toString());
            }
        }
    }

    SelectArRow(row:ARHistoryFile): void {
        this.PrintStatementsArRecordsAgeRadioBox = row;
    }

    PharmChanged(): void {
        //console.log("Pharm changed:" + this.PharmaciesSelectedValue);

        this.PrintStatementsCustomer = null;
        this.TrialBalanceCustomer = null;

        // Request for Print Codes
        const token = JSON.parse(sessionStorage.getItem('data'));
        const tokenPayload = <oAuth>(token);

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
        };

        let PharmaciesIDRequest: PharmaciesIDRequest = {
            Pharmacy_Id: this.PharmaciesSelectedValue.toString()
        }

        var body = JSON.stringify(PharmaciesIDRequest)

        this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOnePrintCodes", body.toString(), options)
            .subscribe(
            (response) => {
                const resp = <PrintCodes>response
                this.PrintCodesRequest = resp;
                this.PrintStatementsPrintCodesRequest = resp;
                this.ArAgePrintCodesRequest = resp;
            },
            (err) => {
                /* this function is executed when there's an ERROR */
                this.openSnackBar("There was an issue with this request", "Error");
            },
            () => {
                /* this function is executed when the observable ends (completes) its stream */
                //this.openSnackBar("Set Batches has completed.", "OK");
            }
        );
        this.GetArHistoryAgingDates();
    }

    TrialBalanceReportTemplatChanged() {
        if (this.TrialBalanceReportTemplateValue == 'Manage Templates') {
            this.TrialBalanceReportTemplateValue = '';
            this.openTemplateUploaderDialog();
        }
    }

    PrintStatementsReportTemplatChanged() {
        if (this.PrintStatementsReportTemplateValue == 'Manage Templates') {
            this.PrintStatementsReportTemplateValue = '';
            this.openTemplateUploaderDialog();
        }
    }

    TrialBalanceReportDownload(): void {
        this.SubmitTrialBalance();
    }

    PrintStatementsReportDownload(): void {
        this.SubmitPrintStatements();
    }

    GetArHistoryAgingDates() {

        // Request for AR Aging dates
        const token = JSON.parse(sessionStorage.getItem('data'));
        const tokenPayload = <oAuth>(token);

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
        };

        let PharmaciesIDRequest: PharmaciesIDRequest = {
            Pharmacy_Id: this.PharmaciesSelectedValue.toString()
        }

        var body = JSON.stringify(PharmaciesIDRequest)

        this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneARHistoryFile", body.toString(), options)
            .subscribe(
            (response) => {
                const resp = <ARHistoryFile[]>response
                this.PrintStatementsARHistoryFile = resp;
            },
            (err) => {
                /* this function is executed when there's an ERROR */
                this.openSnackBar("There was an issue with this request", "Error");
            },
            () => {
                /* this function is executed when the observable ends (completes) its stream */
                //this.openSnackBar("Set Batches has completed.", "OK");
                this.PrintStatementsARHistoryFileDS = new MatTableDataSource<ARHistoryFile>(this.PrintStatementsARHistoryFile);
                this.PrintStatementsARHistoryFileDS.paginator = this.paginator;
            }
            );
    }

    SetBatchesSubmit() {
        window.scrollTo(0, 0);
        this.loading = true;

        const token = JSON.parse(sessionStorage.getItem('data'));
        const tokenPayload = <oAuth>(token);

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
        };

        let RxqOneARSetBatchesRequest: RxqOneARSetBatches = {
            Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
            BatchOption: this.RadioSelectedValue,
            Batch: this.Batch,
            Partition: this.Partition,
            ToDate: this.ToDate,
            FromDate: this.FromDate
        }
        if (RxqOneARSetBatchesRequest.ToDate) {
            RxqOneARSetBatchesRequest.ToDate = this.setDate(RxqOneARSetBatchesRequest.ToDate);
        }
        if (RxqOneARSetBatchesRequest.FromDate) {
            RxqOneARSetBatchesRequest.FromDate = this.setDate(RxqOneARSetBatchesRequest.FromDate);
        }

        var body = JSON.stringify(RxqOneARSetBatchesRequest)

        this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneARSetBatches", body.toString(), options)
            .subscribe(
            (response) => {
                //const resp = <Pharmacies>response
                //this.pharms = resp;
                //console.log(body.toString());
                //console.log(response);

            },
            (err) => {
                /* this function is executed when there's an ERROR */
                this.openSnackBar("There was an issue with this request", "Error");
                this.loading = false;
            },
            () => {
                /* this function is executed when the observable ends (completes) its stream */
                this.loading = false;
                this.openSnackBar("Set Batches has completed.", "OK");
            }
            );
    }
    SubmitTrialBalance() {
        window.scrollTo(0, 0);
        this.loading = true;

        const token = JSON.parse(sessionStorage.getItem('data'));
        const tokenPayload = <oAuth>(token);

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
        };

        var selectedTemplate;

        if (this.TrialBalanceReportTemplateValue == 'Default') {
            selectedTemplate = 'Default'
        }
        else {
            selectedTemplate = JSON.parse(localStorage.getItem(this.TrialBalanceReportTemplateValue));
        }

        let RxqOneARTrialBalanceRequest: RxqOneARTrialBalance = {
            Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
            SetBatchesOption: this.TrialBalanceRadioSelectedValue,
            IncludePrintCode: this.TrialBalancePCcb,
            Printcodes: this.PrintCodesRequest,
            ShowTransactionDetail: this.TrialBalanceTransDetailcb,
            ShowTransactionComment: this.TrialBalanceTransCommentcb,
            ShowAddress: this.TrialBalanceAddresscb,
            OnlyOverdueAccounts: this.TrialBalanceOverduecb,
            AccessFinanceCharges: this.TrialBalanceFinancecb,
            AccessFinanceChargesRange: this.TrialBalanceFinanceChargesValue,
            ServiceFees: this.TrialBalanceServicecb,
            ServiceRange: this.TrialBalanceServiceChargesValue,
            SelectedCustomer: this.TrialBalanceCustomer,
            ReportOption: this.TrialBalanceReportOptionValue,
            ReportTemplate: selectedTemplate
        }

        if (this.PharmaciesSelectedValue.toString() == '0' && this.TrialBalanceReportOptionValue != null) {
            this.pharms.forEach((Pharmacies, index) => {

                RxqOneARTrialBalanceRequest.Pharmacy_Id = Pharmacies.Pharmacy_Id;

                var body = JSON.stringify(RxqOneARTrialBalanceRequest)

                this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneARTrialBalance", body.toString(), options)
                    .subscribe(
                    (response) => {

                        if (this.TrialBalanceReportOptionValue == null) {
                            this.returnimage = <string>response;
                        }
                        else {

                            if (this.TrialBalanceReportOptionValue == 1) {

                                var byteCharacters = atob(<string>response);

                                var byteNumbers = new Array(byteCharacters.length);
                                for (var i = 0; i < byteCharacters.length; i++) {
                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }

                                var byteArray = new Uint8Array(byteNumbers);


                                var blob = new Blob([byteArray], { type: 'applicaton/pdf' });

                                saveAs(blob, "TrialBalance" + Pharmacies.Pharmacy_Name.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".pdf");

                            }
                            if (this.TrialBalanceReportOptionValue == 2) {

                                var byteCharacters = atob(<string>response);

                                var byteNumbers = new Array(byteCharacters.length);
                                for (var i = 0; i < byteCharacters.length; i++) {
                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }

                                var byteArray = new Uint8Array(byteNumbers);
                                var blob = new Blob([byteArray], { type: 'image/jpg' });

                                saveAs(blob, "TrialBalance" + Pharmacies.Pharmacy_Name.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".jpg");

                            }

                            if (this.TrialBalanceReportOptionValue == 3) {

                                var byteCharacters = atob(<string>response);

                                var byteNumbers = new Array(byteCharacters.length);
                                for (var i = 0; i < byteCharacters.length; i++) {
                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }

                                var byteArray = new Uint8Array(byteNumbers);
                                var blob = new Blob([byteArray], { type: 'text/csv' });

                                saveAs(blob, "TrialBalance" + Pharmacies.Pharmacy_Name.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".csv");

                            }

                        }
                    },
                    (err) => {
                        /* this function is executed when there's an ERROR */
                        this.loading = false;
                        this.openSnackBar("There was an issue with this request", "Error");
                    },
                    () => {
                        /* this function is executed when the observable ends (completes) its stream */
                        this.loading = false;
                        this.openSnackBar("Trial Balance has completed.", "OK");
                    }
                    );

            });
        }

        else {

            var body = JSON.stringify(RxqOneARTrialBalanceRequest)

            this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneARTrialBalance", body.toString(), options)
                .subscribe(
                (response) => {

                    if (this.TrialBalanceReportOptionValue == null) {
                        this.returnimage = <string>response;
                    }
                    else {

                        if (this.TrialBalanceReportOptionValue == 1) {

                            var byteCharacters = atob(<string>response);

                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);


                            var blob = new Blob([byteArray], { type: 'applicaton/pdf' });

                            saveAs(blob, "TrialBalance.pdf");

                        }
                        if (this.TrialBalanceReportOptionValue == 2) {

                            var byteCharacters = atob(<string>response);

                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);
                            var blob = new Blob([byteArray], { type: 'image/jpg' });

                            saveAs(blob, "TrialBalance.jpg");

                        }

                        if (this.TrialBalanceReportOptionValue == 3) {

                            var byteCharacters = atob(<string>response);

                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);
                            var blob = new Blob([byteArray], { type: 'text/csv' });

                            saveAs(blob, "TrialBalance.csv");

                        }

                    }
                },
                (err) => {
                    /* this function is executed when there's an ERROR */
                    this.loading = false;
                    this.openSnackBar("There was an issue with this request", "Error");
                },
                () => {
                    /* this function is executed when the observable ends (completes) its stream */
                    this.loading = false;
                    this.openSnackBar("Trial Balance has completed.", "OK");
                }
                );
        }
    }
    setDate(date: any) {
        var s: String = date.toLocaleString();
        s = s.split(",")[0];
        return s;
      }
    SubmitPrintStatements() {


        //console.log(this.pharms);

        //this.pharms.forEach((Pharmacies, index) => {
        //    console.log(Pharmacies);
        //});

        //return;

        window.scrollTo(0, 0);
        this.loading = true;

        const token = JSON.parse(sessionStorage.getItem('data'));
        const tokenPayload = <oAuth>(token);

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
        };

        var selectedTemplate;

        if (this.PrintStatementsReportTemplateValue == 'Default') {
            selectedTemplate = 'Default'
        }
        else {
            selectedTemplate = JSON.parse(localStorage.getItem(this.PrintStatementsReportTemplateValue));
        }

        let RxqOneARPrintStatementsRequest: RxqOneARPrintStatements = {
            Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
            PrintStatementsStatementDate: this.PrintStatementsStatementDate,
            PrintStatementsRadioSelectedValue: this.PrintStatementsRadioSelectedValue,
            PrintStatementsCustomer: this.PrintStatementsCustomer,
            PrintStatementsLastNameRangecb: this.PrintStatementsLastNameRangecb,
            PrintStatementsLastNameBeginning: this.PrintStatementsLastNameBeginning,
            PrintStatementsLastNameEnding: this.PrintStatementsLastNameEnding,
            PrintStatementsPrintCodescb: this.PrintStatementsPrintCodescb,
            PrintStatementsPrintCodesRequest: this.PrintStatementsPrintCodesRequest,
            PrintStatementsDaysRangeValue: this.PrintStatementsDaysRangeValue,
            PrintStatementsPartitionBatchRadio: this.PrintStatementsPartitionBatchRadio,
            PrintStatementsSpecificPartition: this.PrintStatementsSpecificPartition,
            PrintStatementsSpecificBatch: this.PrintStatementsSpecificBatch,
            PrintStatementsOptionsDateRadioBox: this.PrintStatementsOptionsDateRadioBox,
            PrintStatementsOptionsStartDate: this.PrintStatementsOptionsStartDate,
            PrintStatementsOptionsEndDate: this.PrintStatementsOptionsEndDate,
            PrintStatementsShowPostingDetailscb: this.PrintStatementsShowPostingDetailscb,
            PrintStatementsShowCommentcb: this.PrintStatementsShowCommentcb,
            PrintStatementsShowAddresscb: this.PrintStatementsShowAddresscb,
            PrintStatementsNoCurrentPostingcb: this.PrintStatementsNoCurrentPostingcb,
            PrintStatementsZeroAmountDuecb: this.PrintStatementsZeroAmountDuecb,
            PrintStatementsSortingRadioBox: this.PrintStatementsSortingRadioBox,
            PrintStatementsArRecordsRadioBox: this.PrintStatementsArRecordsRadioBox,
            PrintStatementsArRecordsAgeRadioBox: this.PrintStatementsArRecordsAgeRadioBox,
            ReportOption: this.PrintStatementsReportOptionValue,
            ReportTemplate: selectedTemplate
        }
        if (RxqOneARPrintStatementsRequest.PrintStatementsStatementDate) {
            RxqOneARPrintStatementsRequest.PrintStatementsStatementDate = this.setDate(RxqOneARPrintStatementsRequest.PrintStatementsStatementDate);
        }
        if (RxqOneARPrintStatementsRequest.PrintStatementsOptionsStartDate) {
            RxqOneARPrintStatementsRequest.PrintStatementsOptionsStartDate = this.setDate(RxqOneARPrintStatementsRequest.PrintStatementsOptionsStartDate);
        }
        if (RxqOneARPrintStatementsRequest.PrintStatementsOptionsEndDate) {
            RxqOneARPrintStatementsRequest.PrintStatementsOptionsEndDate = this.setDate(RxqOneARPrintStatementsRequest.PrintStatementsOptionsEndDate);
        }
        if (this.PharmaciesSelectedValue.toString() == '0' && this.PrintStatementsReportOptionValue != null) {

        this.pharms.forEach((Pharmacies, index) => {

            RxqOneARPrintStatementsRequest.Pharmacy_Id = Pharmacies.Pharmacy_Id;

            var body = JSON.stringify(RxqOneARPrintStatementsRequest)

            this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneARPrintStatements", body.toString(), options)
                .subscribe(
                (response) => {
                    if (this.PrintStatementsReportOptionValue == null) {
                        this.PrintStatementsreturnimage = <string>response;
                    }
                    else {

                        if (this.PrintStatementsReportOptionValue == 1) {

                            var byteCharacters = atob(<string>response);

                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);


                            var blob = new Blob([byteArray], { type: 'applicaton/pdf' });

                            saveAs(blob, "PrintStatements" + Pharmacies.Pharmacy_Name.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".pdf");

                        }
                        if (this.PrintStatementsReportOptionValue == 2) {

                            var byteCharacters = atob(<string>response);

                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);
                            var blob = new Blob([byteArray], { type: 'image/jpg' });

                            saveAs(blob, "PrintStatements" + Pharmacies.Pharmacy_Name.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".jpg");

                        }

                        if (this.PrintStatementsReportOptionValue == 3) {

                            var byteCharacters = atob(<string>response);

                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);
                            var blob = new Blob([byteArray], { type: 'text/csv' });

                            saveAs(blob, "PrintStatements" + Pharmacies.Pharmacy_Name.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".csv");

                        }

                    }
                },
                //    this.PrintStatementsreturnimage = <string>response;
                //    console.log(response);
                //},
                (err) => {
                    /* this function is executed when there's an ERROR */

                  if (err.error.includes("Record not Found")) {
                    this.openSnackBar("No records found.", "Warning");
                  }
                  else {
                    this.openSnackBar("There was an issue with this request", "Error");
                  }

                    this.loading = false;
                    
                },
                () => {
                    /* this function is executed when the observable ends (completes) its stream */
                    this.loading = false;
                    this.openSnackBar("Print Statements has completed.", "OK");
                }
                );

        });

        }

        else {
            var body = JSON.stringify(RxqOneARPrintStatementsRequest)

            this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneARPrintStatements", body.toString(), options)
                .subscribe(
                (response) => {
                    if (this.PrintStatementsReportOptionValue == null) {
                        this.PrintStatementsreturnimage = <string>response;
                    }
                    else {

                        if (this.PrintStatementsReportOptionValue == 1) {

                            var byteCharacters = atob(<string>response);

                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);


                            var blob = new Blob([byteArray], { type: 'applicaton/pdf' });

                            saveAs(blob, "PrintStatements.pdf");

                        }
                        if (this.PrintStatementsReportOptionValue == 2) {

                            var byteCharacters = atob(<string>response);

                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);
                            var blob = new Blob([byteArray], { type: 'image/jpg' });

                            saveAs(blob, "PrintStatements.jpg");

                        }

                        if (this.PrintStatementsReportOptionValue == 3) {

                            var byteCharacters = atob(<string>response);

                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);
                            var blob = new Blob([byteArray], { type: 'text/csv' });

                            saveAs(blob, "PrintStatements.csv");

                        }

                    }
                },
                //    this.PrintStatementsreturnimage = <string>response;
                //    console.log(response);
                //},
                (err) => {
                    /* this function is executed when there's an ERROR */

                  if (err.error.includes("Record not Found")) {
                    this.openSnackBar("No records found.", "Warning");
                  }
                  else {
                    this.openSnackBar("There was an issue with this request", "Error");
                  }

                    this.loading = false;
                    
                },
                () => {
                    /* this function is executed when the observable ends (completes) its stream */
                    this.loading = false;
                    this.openSnackBar("Print Statements has completed.", "OK");
                }
                );
        }

    }

    SubmitAgeAccounts() {
        this.openArAgeDialog();
    }

    SubmitAgeAccountsConfirm() {
        this.loading = true;
        window.scrollTo(0, 0);
        const token = JSON.parse(sessionStorage.getItem('data'));
        const tokenPayload = <oAuth>(token);

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
        };

        let RxqOneARAgeAccountsRequest: RxqOneARAgeAccounts = {
            Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
            ArAgeRadioSelectedValue: this.ArAgeRadioSelectedValue,
            ArAgePrintcodes: this.ArAgePrintCodesRequest
        }

        var body = JSON.stringify(RxqOneARAgeAccountsRequest)

        this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneARAgeAccounts", body.toString(), options)
            .subscribe(
            (response) => {
                console.log(response);
            },
            (err) => {
                /* this function is executed when there's an ERROR */
                this.loading = false;
                this.openSnackBar("There was an issue with this request", "Error");
            },
            () => {
                /* this function is executed when the observable ends (completes) its stream */
                this.loading = false;
                this.openSnackBar("Age Accounts has completed.", "OK");
            }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/ar/ar.component.ts